export const SET_CAPTCHA_RESPONSE = 'SET_CAPTCHA_RESPONSE';
export const CAPTCHA_VALIDATION_RESPONSE_TOKEN =
  '08AgXDAGhktYRLpskJ8z67FolxAmrm18S0LhqBbUCiLDBqQxjug7UjOr1vO8JvDs';
export const HCAPTCHA_CN_API_HOST = 'https://cn1.hcaptcha.com';
export const HCAPTCHA_CN_ENDPOINT = 'https://cn1.hcaptcha.com';
export const HCAPTCHA_CN_ASSET_HOST = 'https://assets-cn1.hcaptcha.com';
export const HCAPTCHA_CN_IMG_HOST = 'https://imgs-cn1.hcaptcha.com';
export const HCAPTCHA_CN_REPORT_API = 'https://reportapi-cn1.hcaptcha.com';
